// extracted by mini-css-extract-plugin
export default {"social__link":"Social_social__link__-2rcd","social__img":"Social_social__img__V649F"};